import { Controller } from "@hotwired/stimulus"

// This controller is used to reload the page when the feed items is removed from the view and
//   there are no items on the page anymore. We do this since we don't have HTML document on the backend when responding
//   with turbo stream responses.
export default class extends Controller {
  connect() {
    setTimeout(() => {
      if (document.querySelectorAll(".signal-company").length === 0 ) {
        Turbo.visit(window.location.href)
      }
      this.element.remove()
    }, 50)
  }
}
